module.exports = __webpack_public_path__ + "static/media/Redken.d292a5fa.png";